import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/Accordion";
import { CircleCheck } from "lucide-react";

export interface AreaTopic {
  title: string;
  description: string;
}

export function AreaScope({ heading, intro, topics }: { heading: string; intro: string; topics: AreaTopic[] }) {
  return (
    <section className="area-scope shell" aria-labelledby="area-scope-title">
      <div className="area-scope__intro">
        <h2 id="area-scope-title">{heading}</h2>
        <p>{intro}</p>
      </div>
      <Accordion className="area-accordion" type="single" defaultValue="topic-0" collapsible>
        {topics.map((topic, index) => (
          <AccordionItem value={`topic-${index}`} key={topic.title}>
            <AccordionTrigger><span className="area-accordion__label"><CircleCheck aria-hidden="true" />{topic.title}</span></AccordionTrigger>
            <AccordionContent><p>{topic.description}</p></AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
